import { Dialog, DialogContent } from '@mui/material';
import React from 'react';

import IconButton from '@components/IconButton';

import { ModalActions } from '@contexts/modal';

import { useModal } from '@hooks/useModal';

const Modal: React.FC = () => {
  const {
    dispatch,
    state: { children, isOpen = false, width = 300, isPersistent = false },
  } = useModal();

  const handleClose = () => {
    dispatch({ type: ModalActions.Close });
  };

  return (
    <Dialog
      open={isOpen}
      onClose={(_event, reason) => {
        if (
          isPersistent &&
          // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
          (reason === 'backdropClick' || reason === 'escapeKeyDown')
        ) {
          return;
        }
        handleClose();
      }}
    >
      <DialogContent sx={{ maxWidth: width }}>
        {!isPersistent && (
          <IconButton
            onClick={handleClose}
            name="xmark"
            iconType="fas"
            sx={{
              position: 'absolute',
              top: '10px',
              right: '10px',
            }}
          />
        )}
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default Modal;
